// extracted by mini-css-extract-plugin
module.exports = {"poses":"PoseBlock_poses__Yv8Fu"};